import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import './AskConfirmation.scss';
import { Dispatch } from '../../../configs/store';
import { LocationInterface, RouterInterface } from 'src/interfaces/RouterInterface';

interface AskConfirmationProps {
  close: () => void
}

function AskConfirmation ({ close }: AskConfirmationProps) {
  const dispatch = useDispatch<Dispatch>();
  const history = useHistory();
  const { t } = useTranslation('common');
  const location:LocationInterface = useSelector<RouterInterface>(state => state.router);

  const stayhere = async () => {
    await dispatch.events.changeDirtiness(true);
    close();
  };

  const gothere = () => {
    dispatch.events.changeDirtiness(false);
    history.push(location.state?.next);
    close();
  };

  const closeFunction = (e: KeyboardEvent) => {
    if (e.key === 'Enter') gothere();
  };

  useEffect(() => {
    document.addEventListener('keydown', closeFunction);

    return () => {
      document.removeEventListener('keydown', closeFunction);
    };
  });

  return (
    <div className="ask-confirmation">
      <div className="ask-confirmation__title">
        { t('askConfirmation.title') }
      </div>
      <div className="ask-confirmation__sub-title">
        { t('askConfirmation.subTitle') }
      </div>
      <div className="ask-confirmation__buttons">
        <button
          className="ask-confirmation__button ask-confirmation__button--stay"
          onClick={ stayhere }
        >
          { t('askConfirmation.buttonStay') }
        </button>
        <button
          className="ask-confirmation__button ask-confirmation__button--leave modal-submit"
          onClick={ gothere }
        >
          { t('askConfirmation.buttonGo') }
        </button>
      </div>
    </div>
  );
}

export default AskConfirmation;
